
<template>
  <div>
  <Head />
  <Navigation />
  <Row :gutter="40" class='Contact'>
    <Col :md='{span:12,push:3}' :sm='{span:10,push:3}' :xs='{span:20,push:2}'>
      <Row>
        <h3>发票申请 <span></span></h3>
        <div class="post-content">
          <p v-html='content.invoice'>
          </p>
        </div>
      </Row>
      <Row style='margin-top:50px'>
        <h3>公司位置 <span></span></h3>
        <!-- 地图显示框 -->
        <div class="post-content" id='allmap'>
        </div>
      </Row>
    </Col>
    <Col :md='{span:6,push:3}' :sm='{span:8,push:3}' :xs='{span:20,push:2}'>
      <img src="./联系我们+2_03.png" alt="" style="width:550px;height:550px;margin-top:30px">
      <!--<Row>
        <h3>工作时间 <span></span></h3>
        <div class="post-content">
          <Icon type="md-time" /><strong v-html='content.workTime[0]'></strong>
          <br>
          <br>
          <Icon type="md-time" /></Icon>&nbsp;<strong v-html='content.workTime[1]'></strong>
        </div>
      </Row>
      <Row style='margin-top:20px'>
        <h3>总部地址 <span ></span></h3>
        <div class="post-content">
          <ul class="contact-us">
            <li>
              <Icon type="ios-navigate" size="20" />&nbsp;
              <strong v-html='content.address[0]'></strong>
            </li>
            <li>
              <Icon type="md-phone-portrait" size="20" />&nbsp;
              <strong v-html='content.address[1]'></strong>
            </li>
            <li>
              <Icon type="ios-mail" size="20" />&nbsp;
              <strong>Email:<a href="mailto:info@dpihome.com" v-html='content.address[2]'></a></strong>
            </li>
          </ul>
        </div>
      </Row>
      <Row style='margin-top:20px'>
        <h3>乘车线路 <span></span></h3>
        <div class="post-content">
          <Icon type="md-subway" size="20" />&nbsp;
          <strong v-html='content.bus'></strong>
        </div>
      </Row>-->
    </Col>
  </Row>
  <foot />
  </div>
</template>
<script type="text/javascript">
import Head from '@/components/index/components/head'
import Foot from '@/components/index/components/foot'
import Navigation from '@/components/index/components/nav'
export default {
  name: 'ContactInfo',
  components: {
    Head,
    Foot,
    Navigation
  },
  props:['interface'],
  created() {
    this.createFn();
    this.loadJScript();
  },
  methods: {
    // 创建 init函数 先执行
    createFn(){
      let dom;
      dom = document.createElement("script");
      dom.type = "text/javascript";
      dom.id = 'BBmap';
      dom.textContent = `function init(){
          var map = new BMap.Map("allmap");
          var point = new BMap.Point(116.149301,39.731848);
          map.centerAndZoom(point, 16);
          map.enableScrollWheelZoom();
          var marker = new BMap.Marker(point);
          map.addOverlay(marker); 
          marker.setAnimation(BMAP_ANIMATION_BOUNCE);
          map=null;
          point=null;
          marker=null;
        }`;
      document.body.appendChild(dom);
      dom=null;
    },
    //创建script标签指向百度
    loadJScript() {
      let dom;
      dom= document.createElement("script");
      dom.type = "text/javascript";
      dom.src = "http://api.map.baidu.com/api?v=2.0&ak=zoV9tOSs0sfHwmcYydm7EAfM97FaO33s&callback=init";
      dom.id = 'baiduMap';
      document.body.appendChild(dom);
      dom=null;
    }
  },
  data(){
    return {
      content:{
         invoice:'欢迎您的垂询！公司目前可以提供两种发票，增值税普通发票和增值税专用发票；若有需要请在发票申请中提交信息。 发票申请网上填表系统，尚在设计，请电联！',
         workTime:[' 周一 － 周五 上午09:00 至 下午18:00','周六 － 周日 休息'],
         address:['地址:北京市房山区良乡南关西潞大厦','电话:15210550848','info@dpihome.com'],
         bus:'地铁:  房山线-良乡南关站下车'
      }
    }
  }
}

</script>
<style type="text/css" scoped>
.ivu-row {
  position: relative;
  margin-top: 40px;
  margin-bottom: 20px;
  overflow: hidden;
}

#allmap {
  width: 100%;
  height: 300px;
  margin-top: 20px;
}

span {
  display: block;
  background-color: #eee;
  height: 5px;
  width: 100%;
  position: absolute;
  top: 10px;
  left: 100px;
}

p,
ul {
  font-size: 1rem;
  line-height: 30px;
}

.post-content {
  padding-top: 25px;
  font-size: 1.00rem;
}
h3{
  font-size: 1.25rem;
}
</style>
